__webpack_public_path__ = __CLIENT_HOLOCRON_MODULE_MAP__.modules['one-commercial-payments-enrollment-header'].baseUrl;
import ModuleContainer from './components/OneCommercialPaymentsEnrollmentHeader';
export default ModuleContainer;
;
if (!global.BROWSER) {
  ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
    appCompatibility: "^5.0.0"
  });
}
;
if (!global.BROWSER) {
  ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
    requiredExternals: {
      'reactlytics': '^1.2.5',
      '@americanexpress/react-ddl': '^0.3.3'
    }
  });
}